import React from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { DEMO_STAY_LISTINGS } from "data/listings";
import StartRating from "components/StartRating/StartRating";
import { Link } from "react-router-dom";
import ThreeDBadge from "components/SaleOffBadge/3DBadge";

const DEMO_DATA = DEMO_STAY_LISTINGS[0];

const StayCardH = ({ className = "", data = DEMO_DATA }) => {
  const {
    galleryImgs,
    listingCategory,
    address,
    title,
    href,
    like,
    saleOff,
    isAds,
    price,
    reviewStart,
    reviewCount,
    id,
    has3D,
    description,
    amenities = [],
  } = data;

  const renderSliderGallery = () => {
    return (
      <div className="relative flex-shrink-0 w-full md:w-72 ">
        <GallerySlider
          ratioClass="aspect-w-6 aspect-h-5"
          galleryImgs={galleryImgs}
          uniqueID={`StayCardH_${id}`}
          href={href}
        />
        {/* <BtnLikeIcon isLiked={like} className="absolute right-3 top-3" /> */}
        {/* {saleOff && <SaleOffBadge className="absolute left-3 top-3" />}  */}
        {has3D && <ThreeDBadge className="absolute left-3 top-3" />}
        {/* <CubeIcon  className="w-6 h-6 absolute left-3 top-3" />  */}
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <div className="hidden sm:grid grid-cols-3 gap-2">
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            {amenities[0]?.icon || <i className="las la-user text-lg"></i>}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[0]?.name || "Hall"}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            {amenities[3]?.icon || <i className="las la-bed text-lg"></i>}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[3]?.name || "Master bedroom"}
            </span>
          </div>
        </div>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            {amenities[1]?.icon || <i className="las la-bath text-lg"></i>}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[1]?.name || "Barcounter"}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            {amenities[4]?.icon || (
              <i className="las la-smoking-ban text-lg"></i>
            )}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[4]?.name || "Jacuzzi"}
            </span>
          </div>
        </div>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            {amenities[2]?.icon || <i className="las la-door-open text-lg"></i>}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[2]?.name || "Kitchen"}
            </span>
          </div>
          <div className="flex items-center space-x-3">
            {amenities[5]?.icon || <i className="las la-door-open text-lg"></i>}
            <span className="text-sm text-neutral-500 dark:text-neutral-400">
              {amenities[5]?.name || "Dance Floor"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className="flex-grow p-3 sm:p-5 flex flex-col">
        <div className="space-y-2">
          <div className="text-sm text-neutral-500 dark:text-neutral-400">
            <span>{description}</span>
          </div>
          <div className="flex items-center space-x-2">
            <h2 className="text-lg font-medium capitalize">
              <span className="line-clamp-1">{title}</span>
            </h2>
          </div>
        </div>
        <div className="hidden sm:block w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        {renderTienIch()}
        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800 my-4"></div>
        <div className="flex justify-between items-end">
          <StartRating reviewCount={reviewCount} reviewStart={reviewStart} />
          <span className="text-base font-semibold text-secondary-500">
            {price}
            {` `}
            <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
              /slot
            </span>
          </span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow will-change-transform ${className}`}
      data-nc-id="StayCardH"
    >
      <Link to={href} className="absolute inset-0"></Link>
      <div className="grid grid-cols-1 md:flex md:flex-row ">
        {renderSliderGallery()}
        {renderContent()}
      </div>
    </div>
  );
};

export default StayCardH;
